
export const USER_NOTIFICATION = 'admin/user/all';

export const POST_NOTIFICATION = 'admin/user/notification';

export const POST_NOTIFICATION_SINGLE = 'admin/user/notification/user';


